module.exports = __webpack_public_path__ + "static/media/LectureSeriesImg1.4e134672.jpeg";